// Pure-CSS rarity sparkle overlay for TON-minted artworks.
// No JS animation loop, no canvas, no requestAnimationFrame — just a
// handful of absolute-positioned divs that ride the GPU compositor via
// the .ton-sparkle keyframes already defined in index.css. Designed to
// be cheap enough to drop on every card in the gallery without
// noticeably increasing CPU usage.
//
// Color mapping (per user spec):
//   rare        → blue   (#3FA7FF)
//   legendary   → purple (#C084FC)
//   masterpiece → gold   (#F5C842)

const SPARKLE_COLORS = {
  rare:        '#3FA7FF',
  legendary:   '#C084FC',
  masterpiece: '#F5C842',
};

// Fixed sparkle positions so the layout never shifts between renders.
// 4 sparkles total — half the previous count to keep GPU/CPU load
// minimal on devices running the whole gallery feed. Spread across
// edges to give a balanced halo without crowding the artwork centre.
// Each entry: [top%, left%, sizePx, durSec, delaySec].
const SPARKLES = [
  [ 8,  12, 6, 3.0, 0.0],
  [18,  84, 5, 3.4, 0.8],
  [78,  88, 6, 3.2, 0.4],
  [82,  18, 5, 2.9, 1.4],
];

export const TonSparkles = ({ rarity, sizeScale = 1 }) => {
  const color = SPARKLE_COLORS[(rarity || '').toLowerCase()];
  if (!color) return null;
  return (
    <div className="ton-sparkles" data-testid={`ton-sparkles-${rarity}`} aria-hidden="true">
      {SPARKLES.map(([top, left, size, dur, delay], i) => (
        <span
          key={i}
          className="ton-sparkle"
          style={{
            top: `${top}%`,
            left: `${left}%`,
            width: `${size * sizeScale}px`,
            height: `${size * sizeScale}px`,
            '--sparkle-color': color,
            '--sparkle-dur': `${dur}s`,
            '--sparkle-delay': `${delay}s`,
          }}
        />
      ))}
    </div>
  );
};

export default TonSparkles;
